import Api from '../services/Api';

interface ServicoTributoRequest {
  Codigo?: string;
  Descricao?: string;
}

class ServicoController {
  // PROC_SERVICO_ISS_LISTAR (@p_issCode, @p_issDescricao)
  public static async listarISS(request?: ServicoTributoRequest): Promise<any> {
    try {
      const response = await Api.get(`api/servico/ListarISS`, {
        params: {
          Codigo: request?.Codigo,
          Descricao: request?.Descricao,
        },
      });
      return response?.data ?? [];
    } catch (error: any) {
      return [];
    }
  }

  // PROC_SERVICO_NBS_LISTAR (@p_nbsCode, @p_nbsDescricao)
  public static async listarNBS(request?: ServicoTributoRequest): Promise<any> {
    try {
      const response = await Api.get(`api/servico/ListarNBS`, {
        params: {
          Codigo: request?.Codigo,
          Descricao: request?.Descricao,
        },
      });
      return response?.data ?? [];
    } catch (error: any) {
      return [];
    }
  }

  // PROC_SERVICO_OPR_LISTAR (@p_oprCode, @p_oprDescricao)
  public static async listarOperacao(request?: ServicoTributoRequest): Promise<any> {
    try {
      const response = await Api.get(`api/servico/ListarOperacao`, {
        params: {
          Codigo: request?.Codigo,
          Descricao: request?.Descricao,
        },
      });
      return response?.data ?? [];
    } catch (error: any) {
      return [];
    }
  }
}

export default ServicoController;
